require('./notify-tab.component.scss');

class NotifyTabController {
  constructor($scope, $http, PermissionService) {
    this.$scope = $scope;

    if (this.$scope.filter.sendMail === undefined) this.$scope.filter.sendMail = true;
    const schedule =
      (this.$scope.filter.notify ? 'new' : false) ||
      this.$scope.filter.reporting_schedule_type;

    this.$scope.notify2.adminMailShow = `${PermissionService.userName}(${PermissionService.userMail})`;
    this.$scope.notify2.adminMail = PermissionService.userMail
      ? `${PermissionService.userName}<${PermissionService.userMail}>`
      : '';
    this.$scope.notify2.active = !!schedule || this.$scope.filter.send_threshold;

    const getShTime = () =>
      this.$scope.filter.notifyShTime
        ? `${Math.floor(this.$scope.filter.notifyShTime / 3600)
            .toString()
            .padStart(2, '0')}:${Math.floor(
            (this.$scope.filter.notifyShTime % 3600) / 60
          )
            .toString()
            .padStart(2, '0')}`
        : '06:00';

    this.$scope.notify2.shTime = getShTime();

    this.$scope.notify2.changeActive = v => {
      this.$scope.filter.notify = v;
      if (!v) {
        this.$scope.notify2.schedule = '';
        this.$scope.filter.reporting_schedule_type = '';
      } else {
        this.$scope.notify2.schedule = 'new';
        this.$scope.filter.notifyIsHtml = true;
      }
    };

    this.$scope.notify2.schedule = schedule;
    this.$scope.notify2.shTimeBlur = () => {
      const [h, m] = this.$scope.notify2.shTime
        .split(':')
        .map(t => parseInt(t, 0));

      if (
        typeof h === 'number' &&
        typeof m === 'number' &&
        ((h < 24 && m < 60) || (h === 24 && m === 0))
      ) {
        this.$scope.notify2.shTime = `${h
          .toString()
          .padStart(2, '0')}:${m.toString().padStart(2, '0')}`;
      } else {
        console.error('bad shTime', this.$scope.notify2.shTime);
        this.$scope.notify2.shTime = getShTime();
      }
      this.$scope.filter.notifyShTime = getNotifyShTime();
    };

    const getNotifyShTime = () => {
      const [h, m] = this.$scope.notify2.shTime
        .split(':')
        .map(t => parseInt(t, 0));
      return h * 3600 + m * 60;
    };

    this.$scope.notify2.change = v => {
      if (!v) return;
      this.$scope.filter.notify = v === 'new';
      if (v !== 'new') {
        this.$scope.filter.reporting_schedule_type = v;
        this.$scope.filter.notifyIsPdf = true;
        this.$scope.filter.notifyIsHtml = false;
      }
    };

    this.$scope.notify2.isShowSchedule = () =>
      this.$scope.notify2.active && this.$scope.notify2.notifyType !== 'HTML';

    // this.$scope.filter.notifyIsHtml = !!this.$scope.filter.notify;
    this.$scope.notify2.isHtmlChage = v => {
      if (!v) {
        this.$scope.filter.createIncident = false;
        this.$scope.filter.sendMail = true;
        this.$scope.filter.notifyIsPdf = true;
      }
      this.$scope.notify2.setSplitByUsers();
    };
    this.$scope.notify2.isHtmlDisable = () =>
      !this.$scope.notify2.active || this.$scope.notify2.schedule !== 'new';
    // this.$scope.filter.notifyIsPdf = !!this.$scope.filter.reporting_schedule_type;
    this.$scope.notify2.isPdfChange = v => {
      if (!v && !this.$scope.filter.notifyIsHtml)
        this.$scope.filter.notifyIsHtml = true;
      if (!v) this.$scope.filter.save_on_disk = false;
      else {
        this.$scope.filter.createIncident = false;
        this.$scope.filter.sendMail = true;
      }
    };

    this.$scope.notify2.isPdfDisable = () =>
      !this.$scope.notify2.active || this.$scope.notify2.schedule !== 'new';

    this.$scope.notify2.isSendToMe = () =>
      this.$scope.notify2.adminMail && !this.$scope.filter.emails;

    this.$scope.notify2.setSplitByUsers = () => {
      if (!this.$scope.filter.split_by_user) return;
      if (this.$scope.filter.notifyIsHtml)
        this.$scope.filter.split_by_user = false;
    };

    this.$scope.notify2.isPdfDisable = () =>
      !this.$scope.notify2.active || this.$scope.notify2.schedule !== 'new';

    this.$scope.notify2.splitByUsersDisable = () =>
      !this.$scope.notify2.active ||
      this.$scope.filter.do_scan ||
      this.$scope.filter.notifyIsHtml;

    this.$scope.responsePatterns = [];
    this.$scope.incidentGroups = [];

    const initcreateIncident = () => {
      if (
        this.$scope.incidentGroups &&
        this.$scope.incidentGroups[0] &&
        !this.$scope.filter.createIncidentGroup
      )
        this.$scope.filter.createIncidentGroup = this.$scope.incidentGroups[0].id.toString();
      if (
        this.$scope.responsePatterns &&
        this.$scope.responsePatterns[0] &&
        !this.$scope.filter.createIncidentPattern
      )
        this.$scope.filter.createIncidentPattern = this.$scope.responsePatterns[0].id.toString();
    };

    this.$scope.onSendMail = () => {
      if (!this.$scope.filter.notifyIsHtml) this.$scope.filter.sendMail = true;
      if (!this.$scope.filter.sendMail)
        this.$scope.filter.createIncident = true;
    };

    this.$scope.onCreateIncident = () => {
      if (!this.$scope.filter.createIncident) {
        delete this.$scope.filter.createIncidentPattern;
        delete this.$scope.filter.createIncidentGroup;
        this.$scope.filter.sendMail = true;
      }
      // else if ()
      if (
        !this.$scope.responsePatterns.length ||
        !this.$scope.incidentGroups.length
      ) {
        Promise.all([
          $http.get('/incident/api/response_pattern/'),
          $http.get('/incident/api/incident_group/')
        ]).then(
          res => {
            if (res[0] && res[0].data) {
              this.$scope.responsePatterns = res[0].data;
            }
            if (res[1] && res[1].data) {
              this.$scope.incidentGroups = res[1].data;
            }
            initcreateIncident();
            this.$scope.$root.$apply();
          },
          err => {
            console.error(err);
          }
        );
      } else initcreateIncident();
    };
    if (this.$scope.filter.createIncident) this.$scope.onCreateIncident();
  }

  $onInit() {
    this.$scope.notify2.change(this.$scope.notify2.schedule);
    this.$scope.notify2.setSplitByUsers();
  }
}

export function NotifyTabComponent() {
  return {
    restrict: 'E',
    template: require('./notify-tab.component.html'),
    scope: false,
    controller: NotifyTabController
  };
}



// WEBPACK FOOTER //
// ./src/filter/editor/tabs/notify-tab.component.js